import { Component, HostListener, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { GoldPriceService } from '../../../../shared/API-Service/services/GoldPrice.service';
@Component({
  selector: 'app-AddOrUpdateGoldPrice',
  templateUrl: './AddOrUpdateGoldPrice.component.html',
  styleUrls: ['./AddOrUpdateGoldPrice.component.css']
})

export class AddOrUpdateGoldPriceComponent implements OnInit {
  recordtoupdate: any;
  governrate:any
  GoldPriceForm : FormGroup;
update:boolean = false;
button:boolean = false;
  GoldPriceData: any;

  
  constructor(private GoldPriceService:GoldPriceService, private _Router:Router, private _FormBuilder:FormBuilder
  ) { 
    this.initiate();

  }

  GetGoldPrice(){
    this.GoldPriceService.GetGoldPrice().subscribe(async (res) => {
      this.GoldPriceData=await res.data
      this.initiate( this.GoldPriceData);
    })
  }
  ngOnInit(): void {
    this.GetGoldPrice();
  }





  initiate(GoldPriceData?:any){
    this.GoldPriceForm = this._FormBuilder.group({
      karat18: [GoldPriceData?.karat18||0, [Validators.required,Validators.min(1) ]],
      karat21: [GoldPriceData?.karat21||0,[Validators.required,Validators.min(1) ]],
      karat24: [GoldPriceData?.karat24||0, [Validators.required,Validators.min(1) ]],
    });
  }
  get fc() {
    return this.GoldPriceForm.controls;
  }

  onSubmit(){
    this.button = true;
   if(this.GoldPriceForm.status == "VALID"){
  
    this.GoldPriceService.AddOrUpdateGoldPrice(this.GoldPriceForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "Submitted Successfuly",
        showConfirmButton: false,
        timer: 1500,
      });
      this.GetGoldPrice();
      this.button = false ;
      // this._Router.navigate(['/content/ad  min/gold-price']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
   }
   else {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text:"Please check that all the fields are written"   
    })
    this.GoldPriceForm.markAllAsTouched();
    this.button = false;
   }
  }



}
